import ActionCable from 'actioncable'

export default ActionCable
